// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***panels accordian css starts**/
.block {
  margin-bottom: 10px;
  position: relative;
  padding-bottom: 0;
}
.block:last-child:not(::first-child) {
  margin-bottom: 0;
  border: 0;
}
.btnToggleBlock {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
  background-color: #f2f5ff;
  color: #8f9bba;
  cursor: pointer;
  z-index: 2;
  font-size: 0.6rem;
}
.btnToggleBlock::before {
  content: '\\e949';
  font-family: 'icomoon';
}
/*Commenting this code since when the panel is collapse 
only the internal body will be hidden and not the header*/
/* .block.blockCollapse {
  height: 30px;
  overflow: hidden;
} */
.block.blockCollapse .btnToggleBlock::before {
  content: '\\e907';
}
.block > h4 {
  border-bottom: 2px solid rgba(51, 102, 255, 0.24);
  position: relative;
  /*padding-bottom: 8px;*/
  cursor: pointer;
  /* padding: 0; */
  /* padding: 3px 8px; * Added in v17 * */
  padding: 3px 1px;
}
.subPanel {
  margin: 4px 0px 0 25px;
  font-size: 0.9rem;
  color: #776767;
}

.block.borderAdded {
  border: 2px solid rgba(51, 102, 255, 0.24);
  box-shadow: 0 3px 10px rgb(51 102 255 / 20%);
}
.block.borderAdded.pb-40 {
  padding-bottom: 40px;
}

.block.borderAdded > h4 {
  background: rgba(51, 102, 255, 0.24);
  padding: 15px 13px 15px;
}

.customerBody {
  padding: 0px 13px 8px;
}

.block.block.borderAdded > h4 > .btnToggleBlock {
  padding: 18px 10px;
  background: transparent;
}

.block.borderAdded > .subPanel {
  margin: 0px 0px 0 1px;
}
/***panels accordian css ends**/

.block.blockCollapse .panel-body {
  overflow: hidden;
  height: 0px;
}

.panelButton {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/system-common/panel/panel.component.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;yDACyD;AACzD;;;GAGG;AACH;EACE,gBAAgB;AAClB;AACA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;AACA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["/***panels accordian css starts**/\n.block {\n  margin-bottom: 10px;\n  position: relative;\n  padding-bottom: 0;\n}\n.block:last-child:not(::first-child) {\n  margin-bottom: 0;\n  border: 0;\n}\n.btnToggleBlock {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 10px;\n  background-color: #f2f5ff;\n  color: #8f9bba;\n  cursor: pointer;\n  z-index: 2;\n  font-size: 0.6rem;\n}\n.btnToggleBlock::before {\n  content: '\\e949';\n  font-family: 'icomoon';\n}\n/*Commenting this code since when the panel is collapse \nonly the internal body will be hidden and not the header*/\n/* .block.blockCollapse {\n  height: 30px;\n  overflow: hidden;\n} */\n.block.blockCollapse .btnToggleBlock::before {\n  content: '\\e907';\n}\n.block > h4 {\n  border-bottom: 2px solid rgba(51, 102, 255, 0.24);\n  position: relative;\n  /*padding-bottom: 8px;*/\n  cursor: pointer;\n  /* padding: 0; */\n  /* padding: 3px 8px; * Added in v17 * */\n  padding: 3px 1px;\n}\n.subPanel {\n  margin: 4px 0px 0 25px;\n  font-size: 0.9rem;\n  color: #776767;\n}\n\n.block.borderAdded {\n  border: 2px solid rgba(51, 102, 255, 0.24);\n  box-shadow: 0 3px 10px rgb(51 102 255 / 20%);\n}\n.block.borderAdded.pb-40 {\n  padding-bottom: 40px;\n}\n\n.block.borderAdded > h4 {\n  background: rgba(51, 102, 255, 0.24);\n  padding: 15px 13px 15px;\n}\n\n.customerBody {\n  padding: 0px 13px 8px;\n}\n\n.block.block.borderAdded > h4 > .btnToggleBlock {\n  padding: 18px 10px;\n  background: transparent;\n}\n\n.block.borderAdded > .subPanel {\n  margin: 0px 0px 0 1px;\n}\n/***panels accordian css ends**/\n\n.block.blockCollapse .panel-body {\n  overflow: hidden;\n  height: 0px;\n}\n\n.panelButton {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
